export const filtersWrapperStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
  flexWrap: 'wrap',
  flex: 1,
};

export const filterFieldStyles = {
  minWidth: 200,
};

export const dateFieldStyles = {
  minWidth: 160,
};
